<template>
  <div class="addbox">
    <w-row>
      <w-col :span="12" class="other-content">
        <div class="card-title flex">
          可添加成员
          <w-input
            size="small"
            style="width: 240px;"
            v-model="keyword"
            @input="search"
            placeholder="请输入姓名或广联云账号搜索"
          >
            <i slot="prefix" class="r2-icon-action_search"></i>
          </w-input>
          <!--w-button class="mar10" @click="search()">搜索</w-button-->
        </div>
      </w-col>
      <w-col :span="12" class="joined-content">
        <div class="card-title flex">已添加成员{{userListData | addNumFilter}}个</div>
      </w-col>
    </w-row>
    <w-row class="tabbox">
      <w-col :span="12" class="flex-1 other-content padding-left-24">
        <div class="flex users-box-title">
          <span>员工姓名</span>
          <span class="flex-1">员工账号</span>
          <span>操作</span>
        </div>
        <div class="tabcnt">
          <table cellpadding="0" cellspacing="0">
            <template v-for="(item, i) in userList">
              <tr v-if="!item.isAdd" :key="i">
                <td width="90" class="name">
                  <div v-html="item.sname"></div>
                </td>
                <td v-html="item.semail"></td>
                <td width="70">
                  <w-button type="minor" @click="addUser(item)">添加</w-button>
                </td>
              </tr>
            </template>
          </table>
          <div v-if="userList.length==0" class="no-data">
            无可添加成员
          </div>
        </div>
      </w-col>
      <w-col :span="12" class="joined-content padding-right-24">
        <div class="grid-content bg-purple">
          <div class="flex joined-box-title">
            <span>员工姓名</span>
            <span>员工账号</span>
            <span>
              角色
              <el-tooltip class="item" effect="dark" placement="bottom">
                <div slot="content" class="limit-tips">
                  <div class="limit-title">
                    <span></span>
                    <span>项目负责人</span>
                    <span>项目成员</span>
                  </div>
                  <ul class="limit-cnt">
                    <li v-for="(item, index) of opration" :key="index">
                      <span>{{item.name}}</span>
                      <span :class="{'disable':!item.contrl}"><i class="r2-icon-nav_check"></i></span>
                      <span :class="{'disable':!item.edit}"><i class="r2-icon-nav_check"></i></span>
                    </li>
                  </ul>
                </div>
                <i class="r2-icon-action_help_outline" style="line-height: 22px;"></i>
              </el-tooltip>
            </span>
            <span>操作</span>
          </div>
          <div class="tabcnt padding-left-24">
            <table cellpadding="0" cellspacing="0">
              <template v-for="(item,k) in userListData" >
                <tr v-if="item.isAdd" :key="k">
                  <td width="76" class="name">
                    <div>{{item.name}}</div>
                  </td>
                  <td width="208">{{item.email}}</td>
                  <td width="150" v-if="item.roleType === 2">项目库管理员</td>
                  <td width="150" v-else>
                    {{item.role == 1? '项目负责人' : '项目成员'}}
                    <w-dropdown @command="handlerAction">
                      <span class="over-choose-icon">
                        <i class="r2-icon-nav_arrow_drop_down"></i>
                      </span>
                      <w-dropdown-menu slot="dropdown">
                        <w-dropdown-item :disabled="item.role === 1" :command="{item, value: 1}">
                          <span :class="{'color-blue': item.role === 1}">项目负责人</span>
                        </w-dropdown-item>
                        <w-dropdown-item :disabled="item.role !== 1" :command="{item, value: 2}">
                          <span :class="{'color-blue': item.role !== 1}">项目成员</span>
                        </w-dropdown-item>
                      </w-dropdown-menu>
                    </w-dropdown>
                  </td>
                  <td width="100" class="text-align-center">
                    <w-button type="minor" @click="delUser(item)">移除</w-button>
                  </td>
                </tr>
              </template>
            </table>
          </div>
        </div>
      </w-col>
    </w-row>
  </div>
</template>

<script>
import ProJectSpaceService from '@/assets/service/space'
import { getCookie } from '@/assets/utils/CommonUtil'
const opration = [
  {name: '上传', contrl: true, edit: true},
  {name: '下载', contrl: true, edit: true},
  {name: '重命名', contrl: true, edit: true},
  {name: '新建文件夹', contrl: true, edit: true},
  {name: '移动', contrl: true, edit: true},
  {name: '删除', contrl: true, edit: true},
  {name: '添加/删除成员', contrl: true, edit: false},
  {name: '清空回收站', contrl: true, edit: false},
  {name: '备案项目', contrl: true, edit: false}
]
export default {
  data () {
    return {
      keyword: '',
      userList: [],
      userListData: [],
      enterpriseName: '',
      workspaceId: getCookie('projectWorkspaceIdValue'),
      user: {},
      opration
    }
  },
  props: {
    sellist: Array,
    AddMemberShow: Boolean,
    MemberInfo: Object,
    isadd: Boolean,
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'MemberInfo.MemberShow': {
      handler: function () {
        this.getUserList()
      }
    },
    AddMemberShow (data) {
      this.initSelList()
    }
  },
  filters: {
    addNumFilter: function (list){
      let num = 0
      list.map((item) => {
        if (item.isAdd){
          num++
        }
      })
      return num
    }
  },
  methods: {
    // 下拉菜单指令事件
    handlerAction ({item, value}) {
      if (value === 1) {
        this.$confirm({
          message: `除总负责人外，只能有一个成员拥有“项目负责人”权限，${this.isAdmin ? '当前项目负责人' : '您'}在此项目中的权限将由“项目负责人”变为“项目成员”，确定要将${item.name}用户权限设置为“项目负责人”？`,
          width: 500,
          submit: () => {
            this.handleClick(item, value)
          }
        })
      } else {
        this.handleClick(item, value)
      }
    },
    initSelList () {
      let selUser = []
      this.sellist.map(item => {
        selUser.push(item.id)
      })
      this.userListData = this.userListData.map(item => {
        return {
          ...item,
          isAdd: selUser.indexOf(item.id) > -1
        }
      })
      this.userList = this.userList.map(item => {
        return {
          ...item,
          isAdd: selUser.indexOf(item.id) > -1
        }
      })
    },
    confirm () {
      let sellist = []
      this.userListData.map(item => {
        if (item.isAdd) {
          sellist.push(item)
        }
      })
      this.$emit('sellListCallBack', sellist)
      this.close(true)
    },
    // 2.1 关闭弹框
    close () {
      this.keyword = ''
      this.search(true)
      this.$emit('closeMemberShow', true)
    },
    search (flag) {
      let userlist = [...this.userListData]
      if (this.keyword === '') {
        this.userList = userlist
        return
      }
      userlist = userlist
        .filter(item => {
          if (
            item.name &&
            item.name.toUpperCase().indexOf(this.keyword.toUpperCase()) > -1
          ) {
            return true
          }
          if (
            item.email &&
            item.email.toUpperCase().indexOf(this.keyword.toUpperCase()) > -1
          ) {
            return true
          }
          return false
        })
        .map(item => {
          let name = item.name
          let email = item.email
          let regfirst = /[0-9a-zA-Z]/
          if (name) {
            if (regfirst.test(this.keyword[0])) {
              name = name.replace(
                new RegExp(this.keyword, 'g'),
                `<span class="red">${this.keyword}</span>`
              )
            } else {
              name = name.replace(
                new RegExp('\\' + this.keyword, 'g'),
                `<span class="red">${this.keyword}</span>`
              )
            }
          }
          if (email) {
            if (regfirst.test(this.keyword[0])) {
              email = email.replace(
                new RegExp(this.keyword, 'g'),
                `<span  class="red">${this.keyword}</span>`
              )
            } else {
              email = email.replace(
                new RegExp('\\' + this.keyword, 'g'),
                `<span  class="red">${this.keyword}</span>`
              )
            }
          }
          return {
            ...item,
            semail: email,
            sname: name
          }
        })
      this.userList = userlist
    },
    addUser (item) {
      this.userListData.forEach((useritem, index) => {
        if (useritem.id === item.id) {
          useritem.isAdd = true
          useritem.role = 2
        }
      })
      this.userList.forEach((useritem, index) => {
        if (useritem.id === item.id) {
          useritem.isAdd = true
          useritem.role = 2
        }
      })
    },
    delUser (item) {
      this.userListData.forEach((useritem, index) => {
        if (useritem.id === item.id) {
          useritem.isAdd = false
        }
      })
      this.userList.forEach((useritem, index) => {
        if (useritem.id === item.id) {
          useritem.isAdd = false
        }
      })
    },
    getUserList () {
      let param = {}
      if (this.MemberInfo) {
        let projectId = this.$route.params.id
        param.projectId = projectId
      }
      ProJectSpaceService.getUserList(param, this.headers).then(ret => {
        if (+ret.code === 200) {
          let userList = ret.data.map(item => {
            return {
              name: item.userName,
              email: item.account,
              sname: item.userName,
              semail: item.account,
              id: item.gldUserId,
              memberId: item.gldUserId,
              isAdd: false,
              roleType: item.roleType
            }
          })

          this.userList = userList
          this.userListData = [...userList]
          this.enterpriseName = ret.data.enterpriseName
        }
      })
    },
    handleClick (item, key) {
      item.visible = false
      this.userListData.map((item) => {
        item.role = 2
      })
      item.role = key
      this.$forceUpdate()
    }
  },
  created () {
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo) {
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    this.getUserList()
  }
}
</script>

<style lang="less">
.no-data{
  text-align: center;
  line-height: 300px;
  font-weight:400;
  color:rgba(33,37,48,0.55);
  font-size:12px;
}
.role-box{
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 8px 0px rgba(33,37,48,0.2);
  border-radius:4px;
  padding: 4px 8px;
  .role-item{
    line-height:32px;
    padding: 0 8px;
    &:hover{
      background: rgba(243,244,247,1);
    }
  }
  .active-menu-item{
    color: #2079FA;
  }
}
.addbox {
  box-sizing: border-box;
  .r2-icon-action_help_outline.item{
    line-height: 22px;
    position: relative;
    top: -2px;
  }
  .padding-right-24 {
    padding-right: 24px;
  }
  .padding-left-24 {
    padding-left: 24px;
  }
  .title {
    height: 56px;
    line-height: 46px;
    padding-left: 24px;
    font-size: 16px;
    font-weight: 500;
    color: rgba(33, 37, 48, 1);
    position: relative;
    box-shadow: 0px 1px 0px 0px rgba(33, 37, 48, 0.1);
    border-radius: 4px 4px 0px 0px;
  }
  .card-title {
    line-height: 48px;
    height: 48px;
    padding: 0 8px 0 24px;
    font-weight: 500;
    font-size: 14px;
    color: rgba(33, 37, 48, 1);
    justify-content: space-between;
  }
  .other-content {
    box-sizing: border-box;
  }
  .joined-content {
    box-sizing: border-box;
    /*width: 630px;*/
    border-left: 1px solid rgba(222, 223, 224, 1);
  }
  .close {
    position: absolute;
    right: 10px;
    font-size: 30px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    color: #cdcfd3;

    &:hover {
      color: #333;
    }
  }
  .cnt {
    padding: 20px 20px 0px;
  }
  .mar10 {
    margin-left: 10px;
  }
  .tabcnt {
    height: 383px;
    overflow: auto;
    table {
      width: 100%;
      font-size: 14px;
      font-weight:400;
      color:rgba(33,37,48,0.8);
      td {
        height: 44px;
        .red {
          color: red;
        }
      }
      .name {
        width: 100px;
        div {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100px;
        }
      }
      .name2 {
        padding-left: 10px;
        width: 100px;
        div {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100px;
        }
      }
    }
  }
  .users-box-title {
    span {
      line-height: 44px;
      font-size: 12px;
      font-weight: 500;
      color: rgba(33, 37, 48, 0.8);
      overflow: hidden;
      padding: 0 12px;
      &:first-child {
        padding-left: 0;
        width: 90px;
        overflow: hidden;
      }
      &:nth-child(3) {
        width: 70px;
        text-align: center;
      }
    }
  }
  .joined-box-title {
    span {
      line-height: 44px;
      font-size: 12px;
      font-weight: 500;
      color: rgba(33, 37, 48, 0.8);
      overflow: hidden;
      padding: 0 12px;
      &:first-child {
        padding-left: 24px;
        width: 115px;
        overflow: hidden;
      }
      &:nth-child(2) {
        width: 246px;
      }
      &:nth-child(3) {
        width: 150px;
      }
      &:nth-child(4) {
        width: 120px;
        text-align: center;
      }
    }
  }
  .tabbox {
    height: 432px;
    border-top: 1px solid rgba(222, 223, 224, 1);
    border-bottom: 1px solid rgba(222, 223, 224, 1);
  }
  .over-choose-icon{
    margin-left: 15px;
    border-radius:4px;
    border:1px solid rgba(33,37,48,0.55);
    line-height: 22px;
    &:hover{
      color: #2079FA;
      border-color: rgba(32,121,250,1);
    }
  }
  .foot {
    text-align: right;
    padding-right: 20px;
    padding-top: 20px;
  }

  ::-webkit-scrollbar {
    width: 6px; /*对垂直流动条有效*/
    height: 10px; /*对水平流动条有效*/
  }

  /*定义滚动条的轨道颜色、内阴影及圆角*/
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    background-color: rgba(0, 0, 0, 0);
    border-radius: 3px;
  }

  /*定义滑块颜色、内阴影及圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 3px;
    -webkit-box-shadow: inset 0 0 6px rgba(133, 135, 141, 1);
    background-color: rgba(133, 135, 141, 1);
  }
}
.limit-title {
  width: 300px;
  padding: 0 10px;
  line-height: 44px;
  span {
    display: inline-block;
    &:nth-child(1) {
      width: 90px;
      text-align: left;
    }
    &:nth-child(2) {
      width: 90px;
      text-align: center;
      color: #fff;
    }
    &:nth-child(3) {
      width: 90px;
      text-align: center;
      color: #fff;
    }
  }
}

.limit-cnt {
  padding: 0 10px;
  width: 300px;
  box-sizing: border-box;
  span {
    display: inline-block;
    line-height: 32px;
    &:nth-child(1) {
      width: 90px;
      text-align: left;
    }
    &:nth-child(2) {
      width: 90px;
      text-align: center;
      color: #00c461;
      &.disable {
        color: #4a4f58;
      }
    }
    &:nth-child(3) {
      width: 90px;
      text-align: center;
      color: #00c461;
      &.disable {
        color: #4a4f58;
      }
    }
  }
}
</style>
